var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "sms" } },
    [
      _c(
        "transition-group",
        { attrs: { name: "fade01", mode: "out-in" } },
        [
          _c("el-card", { key: "sms", staticClass: "box-card" }, [
            _c(
              "div",
              {
                staticClass: "clearfix",
                attrs: { slot: "header" },
                slot: "header"
              },
              [
                _c("span", [
                  _c("i", { staticClass: "el-icon-bank-card" }),
                  _vm._v(
                    "\n          ご本人確認をSMS認証を行うため電話番号と会員の方は生年月日をご入力ください\n        "
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "text item" }, [
              _c(
                "div",
                { staticClass: "cregit_form" },
                [
                  _vm.sms.send_error_message
                    ? _c(
                        "p",
                        { staticClass: "send_error_message" },
                        [
                          _c("el-alert", {
                            attrs: {
                              title: _vm.sms.send_error_message,
                              effect: "dark",
                              closable: false,
                              type: "error"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("el-input", {
                            attrs: {
                              id: "tel",
                              name: "tel",
                              placeholder: "SMS",
                              type: "tel",
                              maxlength: "11"
                            },
                            on: { input: _vm.smsInput },
                            model: {
                              value: _vm.sms.val,
                              callback: function($$v) {
                                _vm.$set(_vm.sms, "val", $$v)
                              },
                              expression: "sms.val"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 7 } },
                        [
                          _c("el-input", {
                            attrs: {
                              id: "birthday",
                              name: "birthday",
                              placeholder: "生年月日の入力",
                              maxlength: "8",
                              type: "tel"
                            },
                            model: {
                              value: _vm.birthday_num,
                              callback: function($$v) {
                                _vm.birthday_num = $$v
                              },
                              expression: "birthday_num"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("el-col", { attrs: { span: 5 } }, [
                        _c(
                          "div",
                          { staticClass: "button_area" },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  id: "smsSend",
                                  type: "primary",
                                  icon: "el-icon-arrow-right",
                                  disabled: _vm.disabledButton,
                                  loading: _vm.smsSendButtonLoading
                                },
                                on: { click: _vm.handleCooperate }
                              },
                              [_vm._v("SMSを送信")]
                            )
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("p", { staticClass: "input_sample" }, [
                    _vm._v(
                      "電話番号のご入力例 必ず11桁以上の数字でご入力ください「08078924512」"
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "input_sample" }, [
                    _vm._v(
                      "生年月日のご入力例 1986年05月16日生まれの場合「19860516」"
                    )
                  ])
                ],
                1
              )
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.sms.dialog,
            width: "400px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.sms, "dialog", $event)
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "sms" },
            [
              _c("h2", { staticClass: "sms__ttl" }, [
                _c("i", { staticClass: "el-icon-lock sms__icon" }),
                _vm._v(" 認証コード入力")
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "sms__txt" }, [
                _vm._v("届いた4桁のコードを入力してください。")
              ]),
              _vm._v(" "),
              _vm.sms.error_message
                ? _c(
                    "p",
                    { staticClass: "error_message" },
                    [
                      _c("el-alert", {
                        attrs: {
                          title: _vm.sms.error_message,
                          effect: "dark",
                          closable: false,
                          type: "error"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("el-input", {
                attrs: {
                  id: "code",
                  name: "code",
                  type: "tel",
                  maxlength: "4",
                  "show-word-limit": ""
                },
                on: { input: _vm.inputCheck },
                model: {
                  value: _vm.sms.code,
                  callback: function($$v) {
                    _vm.$set(_vm.sms, "code", $$v)
                  },
                  expression: "sms.code"
                }
              }),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "sms__btn",
                  attrs: {
                    id: "codeSend",
                    type: "primary",
                    disabled: _vm.disabledCodeButton
                  },
                  on: { click: _vm.checkCode }
                },
                [_vm._v("送信")]
              ),
              _vm._v(" "),
              _c("el-divider"),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "skip__btn",
                  attrs: { type: "text", disabled: _vm.disabledSkipButton },
                  on: { click: _vm.skipCheckCode }
                },
                [_vm._v("認証コードが届かない方はこちら")]
              ),
              _vm._v(" "),
              _vm.getHasPayment === "credit"
                ? _c("p", { staticClass: "skip__txt" }, [
                    _vm._v(
                      "\n        認証コードが届かない場合、お客様の携帯電話にトリプルクラウンから本人確認電話をさせていただきます。\n      "
                    )
                  ])
                : _vm._e()
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }